import { useTranslate } from "react-admin";

import { CustomConfirm } from "../CustomConfirm";

export type LearningAssignmentDialogTarget = {
  caregiverName: string;
  contentTitle: string;
  assigned: boolean;
  expired: boolean;
};

type LearningAssignmentDialogProps = {
  target: LearningAssignmentDialogTarget | null;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const LearningAssignmentDialog = ({ target, loading, onConfirm, onClose }: LearningAssignmentDialogProps) => {
  const translate = useTranslate();
  const assigning = target?.assigned === false;

  return (
    <CustomConfirm
      isOpen={target != null}
      title={translate(
        assigning ? "learningAssignments.dialog.assignTitle" : "learningAssignments.dialog.unassignTitle"
      )}
      content={translate(
        assigning
          ? "learningAssignments.dialog.assignContent"
          : target?.expired
            ? "learningAssignments.dialog.expiredUnassignContent"
            : "learningAssignments.dialog.unassignContent",
        {
          caregiver: target?.caregiverName ?? "",
          title: target?.contentTitle ?? "",
        }
      )}
      loading={loading}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
